import styled from "styled-components";

export default styled.div`
  position: relative;
  width: 100%;
  .player__wrapper {
    position: relative;
    .player__container {
      padding-top: 55%;
      .videoDetailBox {
        position: absolute;
        left: 0px;
        right: 0px;
        top: 0px;
        bottom: 0px;
        background: rgb(0, 0, 0) none repeat scroll 0% 0%;

        video-js {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .video--description {
    margin-top: 10px;
    margin-bottom: 15px;
    line-height: 28px;
    font-size: 16px;
    letter-spacing: 0.48px;
    color: rgba(0, 0, 0, 0.87);
    white-space: pre-wrap;
  }

  .mobile__collapse {
    display: flex;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
    .mobile__description {
      margin-top: 15px;
    }
    div {
      flex: 1 1 auto;
    }
    button {
      border-radius: 50% !important;
      padding: 8px;
      svg {
        font-size: 18px;
      }
    }
  }

  @media screen and (max-width: 991px) {
    .video--description {
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.38px;
    }
  }
`;
